module.exports = __webpack_public_path__ + "static/media/fresh_spearmint.e09e421c.png";